import { Button } from '@rr/ui'
import { ArrowRight } from 'lucide-react'
import { APP_URL } from '../lib/links'

export function CTA() {
  return (
    <section className="border-b border-border">
      <div className="max-w-6xl mx-auto px-6 lg:px-10 py-20 lg:py-28">
        <div className="relative rounded-3xl border border-border bg-background overflow-hidden">
          <div className="absolute inset-0 bg-grid pointer-events-none opacity-60" aria-hidden />
          <div
            className="absolute inset-0 pointer-events-none"
            aria-hidden
            style={{
              background:
                'radial-gradient(ellipse 60% 80% at 50% 0%, hsl(var(--primary) / 0.18), transparent 70%)',
            }}
          />
          <div className="relative px-6 lg:px-12 py-14 lg:py-16 text-center max-w-2xl mx-auto">
            <h2 className="text-[32px] sm:text-[40px] leading-tight font-semibold tracking-tight">
              Indiki ýüküňize minutlarda baha beriň.
            </h2>
            <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
              <Button asChild size="lg">
                <a href={APP_URL} className="gap-2">
                  Programmany aç
                  <ArrowRight className="w-4 h-4" />
                </a>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
